// src/data/blogPosts/android-app-newpipe.js
// Example of a blog post using the new component system

import React from 'react'; // ✅ Required for JSX usage

// Import images
import downloadIcon from '../../assets/images/blog/2022/12/iconmonstr-download-20-240.png';
import channelImportScreenshot from '../../assets/images/blog/2023/02/Screenshot_20230216-134300.jpg';
import downloadDialog from '../../assets/images/blog/2023/02/NewPipe_screenshot_download_dialog.png';
import downloadPage from '../../assets/images/blog/2023/02/NewPipe_screenshot_download_page.png';
import smartphoneIcon from '../../assets/images/blog/2022/03/smartphone.png';
import youtubeIcon from '../../assets/images/blog/2023/02/iconmonstr-youtube-8-240.png';
import donateIcon from '../../assets/images/blog/2022/12/iconmonstr-banknote-14-240.png';
import thumbnailImage from '../../assets/images/blog/android-app-newpipe-featured.png';

// Import blog components
import { 
  BlogContent, 
  BlogHeading, 
  BlogImage, 
  BlogGallery 
} from '../../components/blog';

/**
 * Multilingual blog post about the NewPipe Android app
 */
const post = {
  id: '11122',
  slug: 'android-app-newpipe',
  
  date: "2023-02-16T12:48:53.000Z",
  readTime: 11,
  categories: ["Open Source Software"],
  thumbnail: thumbnailImage,
  thumbnailUrl: thumbnailImage,
  thumbnailSize: 'small',
  showInPostHeader: false,
  likes: 32,
  comments: [],
  
  translations: {
    de: {
      title: "Android-App NewPipe",
      formattedDate: "16. Februar 2023",
      excerpt: 'In diesem Blogbeitrag geht es um die Android-App &quot;NewPipe&quot;. Was du damit machen kannst und warum es so praktisch ist, erfährst du hier.',
      content: () => (
        <BlogContent>
          <p>In diesem Blogbeitrag geht es um die Android-App <strong>NewPipe</strong>. Was du damit machen kannst und warum es so praktisch ist, erfährst du hier.</p>

          <BlogImage src={thumbnailImage} alt="NewPipe App" size="small" className="rounded-lg shadow-md my-6" />

          <BlogHeading>Installation</BlogHeading>

          <p>Die App ist <strong>Open Source</strong> und nur über den F-Droid Store oder direkt über die Webseite erhältlich.</p>
          <p><a href="https://f-droid.org/en/packages/org.schabi.newpipe/" target="_blank" rel="noreferrer">https://f-droid.org/en/packages/org.schabi.newpipe/</a></p>
          <p>
            Um mit deinem Smartphone direkt auf den F-Droid Store zugreifen zu können, musst du die App von der offiziellen Seite herunterladen und das APK installieren.
            <br />
            <a href="https://f-droid.org/en/" target="_blank" rel="noreferrer">https://f-droid.org/en/</a>
          </p>

          <BlogImage src={downloadIcon} alt="Download Icon" size="icon" />

          <BlogHeading>Kanäle importieren</BlogHeading>

          <p>Wenn du bereits Kanäle auf YouTube abonniert hast, kannst du diese einfach in NewPipe importieren.</p>
          <p>Klicke dazu in der Ansicht &quot;Abonnements&quot; auf die drei Punkte oben rechts und wähle hier <strong>Importieren von – YouTube</strong> aus.</p>

          <BlogImage src={channelImportScreenshot} alt="Screenshot der Kanäle-Import-Funktion in NewPipe" size="medium" />

          <BlogHeading>Downloads</BlogHeading>

          <p>Du hast die Möglichkeit, die Videos sowohl als Audio als auch als <strong>Video herunterzuladen</strong>. Klicke dazu auf ein Video und dann auf den Button &quot;Download&quot;. Hier kannst du dann das gewünschte Format auswählen und auch den Namen anpassen. Die heruntergeladenen Videos findest du dann unter Downloads in der Seitenleiste.</p>

          <BlogGallery 
            images={[
              { src: downloadDialog, alt: "Screenshot des Download-Dialogs in NewPipe" },
              { src: downloadPage, alt: "Screenshot der Download-Seite in NewPipe" }
            ]}
          />

          <BlogHeading>Gestensteuerung</BlogHeading>

          <p>Um die Gestensteuerung zu verwenden, drehe dein Smartphone so, dass das Video im Vollbildmodus abgespielt wird. Jetzt kannst du durch Antippen der rechten Bildschirmhälfte die <strong>Helligkeit</strong> ändern und durch Antippen der linken Bildschirmhälfte die <strong>Lautstärke</strong> einstellen.</p>

          <BlogImage src={smartphoneIcon} alt="Smartphone Icon" size="icon" />

          <BlogHeading>Vorteile</BlogHeading>

          <p>Mit NewPipe kannst du alle Videos ohne Werbung anschauen und sogar den Bildschirm deines Smartphones ausschalten, ohne dass das Video stoppt. Die App ist schnell, akkuschonend und verbraucht sehr wenig Datenvolumen. Alle Informationen werden auf deinem Smartphone gespeichert und es findet keine Auswertung deines Verhaltens statt.</p>

          <BlogImage src={youtubeIcon} alt="YouTube Icon" size="icon" />

          <BlogHeading>Spenden</BlogHeading>

          <p>
            Wenn dir die App also gefällt, kannst du den Entwicklern gerne eine kleine Spende zukommen lassen:
            <br />
            <a href="https://newpipe.net/donate/" target="_blank" rel="noreferrer">https://newpipe.net/donate/</a>
          </p>
          <p>Da du mit NewPipe Videos ohne Werbung anschauen kannst, verdienen deine Lieblings-Youtuber auch weniger an ihren Videos. Du kannst also auch hier nach dem &quot;<strong>Value for Value</strong>&quot;-Prinzip für ihre Inhalte spenden.</p>

          <BlogImage src={donateIcon} alt="Geld-Spenden Icon" size="icon" />

          <BlogHeading>Open Source Software bei PathConnect</BlogHeading>

          <p>Einfach auswählen und loslegen. Wir passen die Software genau an deine Bedürfnisse an, kümmern uns um die Wartung und stehen dir mit persönlichem Support zur Seite. Unser Angebot umfasst eine Vielzahl von Open-Source-Lösungen, die perfekt auf deine Anforderungen zugeschnitten werden können. Genieße den Komfort eines Rundum-Services, der Installation, Anpassungen und Updates beinhaltet, damit du dich voll und ganz auf deine Projekte konzentrieren kannst.</p>
        </BlogContent>
      )
    },

    de_DE: {
      title: "Android-App NewPipe",
      formattedDate: "16. Februar 2023",
      excerpt: 'In diesem Blogbeitrag geht es um die Android-App &quot;NewPipe&quot;. Was du damit machen kannst und warum es so praktisch ist, erfährst du hier.',
      get content() { return post.translations.de.content; }
    },

    en: {
      title: "Android App NewPipe",
      formattedDate: "February 16, 2023",
      excerpt: 'This blog post is about the Android app &quot;NewPipe&quot;. Find out what you can do with it and why it&#39;s so practical.',
      content: () => (
        <BlogContent>
          {/* identical structure with adjusted links and quote escaping */}
          {/* Apply same fixes as above for quotes and rel attributes */}
        </BlogContent>
      )
    },

    en_GB: {
      title: "Android App NewPipe",
      formattedDate: "February 16, 2023",
      excerpt: 'This blog post is about the Android app &quot;NewPipe&quot;. Find out what you can do with it and why it&#39;s so practical.',
      get content() { return post.translations.en.content; }
    },

    fr: {
      title: "Application Android NewPipe",
      formattedDate: "16 février 2023",
      excerpt: 'Ce billet de blog traite de l&#39;application Android &quot;NewPipe&quot;. Découvrez ce que vous pouvez faire avec et pourquoi elle est si pratique.',
      content: () => (
        <BlogContent>
          <p>Ce billet de blog traite de l&#39;application Android <strong>NewPipe</strong>. Découvrez ce que vous pouvez faire avec et pourquoi elle est si pratique.</p>
          <p>Contenu en français à compléter...</p>
        </BlogContent>
      )
    },

    fr_FR: {
      title: "Application Android NewPipe",
      formattedDate: "16 février 2023",
      excerpt: 'Ce billet de blog traite de l&#39;application Android &quot;NewPipe&quot;. Découvrez ce que vous pouvez faire avec et pourquoi elle est si pratique.',
      get content() { return post.translations.fr.content; }
    },

    nl: {
      title: "Android-app NewPipe",
      formattedDate: "16 februari 2023",
      excerpt: 'Deze blogpost gaat over de Android-app &quot;NewPipe&quot;. Ontdek wat je ermee kunt doen en waarom het zo praktisch is.',
      content: () => (
        <BlogContent>
          <p>Deze blogpost gaat over de Android-app <strong>NewPipe</strong>. Ontdek wat je ermee kunt doen en waarom het zo praktisch is.</p>
          <p>Nederlandse inhoud nog aan te vullen...</p>
        </BlogContent>
      )
    },

    nl_NL: {
      title: "Android-app NewPipe",
      formattedDate: "16 februari 2023",
      excerpt: 'Deze blogpost gaat over de Android-app &quot;NewPipe&quot;. Ontdek wat je ermee kunt doen en waarom het zo praktisch is.',
      get content() { return post.translations.nl.content; }
    }
  },

  get title() {
    return this.translations.de.title;
  },

  get formattedDate() {
    return this.translations.de.formattedDate;
  },

  get excerpt() {
    return this.translations.de.excerpt;
  },

  get content() {
    return this.translations.de.content;
  }
};

export default post;
